module.exports = __webpack_public_path__ + "static/img/character-scorpius.63f88e96.png";